<div class="doubt-section-bg">
  <div class="doubt-section-content">
    <h2 class="headline">Lass dich nicht von Zweifeln bremsen</h2>
    <p class="subheadline">
      Gewinner treffen Entscheidungen! Finde jetzt heraus, ob die No. 1 Akademie auch für dich geeignet ist!
    </p>
    <app-apply-button></app-apply-button>
  </div>
</div> 